import { Address } from 'viem';

export const NFT_BONDS: Address = '0xC9132f1a03A16518b3EA55a0Cd2E24bAcbc862d4';
export const NFT_REDEMPTION: Address =
  '0x38aCc4510DaE0DD289D28613da9872CFBFEf3E81';
export const REWARD_POOL: Address =
  '0xcbf8B303fFf8472EA126ac529fCBcEBe803aDB30';
